// Material Dashboard 2 React example components
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import DataTable from "examples/Tables/DataTable";
// Data
import { useEffect, useState } from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const shortened = (address) => {
  return address.substring(0, 4) + "..." + address.slice(-4);
};

function PredictionStats() {
  const [dateTo, setDateTo] = useState(new Date(moment.utc()));
  const [dateFrom, setDateFrom] = useState(
    new Date(moment.utc().subtract(7, "days"))
  );
  const [data, setData] = useState();
  const [canUpdate, setCanUpdate] = useState(true);
  const [bets, setBets] = useState();

  useEffect(() => {
    if (!data || !data.dailyBetStats) return;

    // Calculate totals
    const totalBets = data.dailyBetStats.reduce(
      (sum, day) => sum + day.totalBet,
      0
    );
    const totalWon = data.dailyBetStats.reduce(
      (sum, day) => sum + day.amountWon,
      0
    );
    const totalCount = data.dailyBetStats.reduce(
      (sum, day) => sum + day.count,
      0
    );

    // Create rows including the summary row
    const rows = [
      ...data.dailyBetStats.map((day) => {
        return {
          date: day._id,
          totalBet: day.totalBet.toFixed(2),
          amountWon: day.amountWon.toFixed(2),
          houseProfit: (day.totalBet - day.amountWon).toFixed(2),
          count: day.count,
        };
      }),
      {
        date: "TOTAL",
        totalBet: totalBets.toFixed(2),
        amountWon: totalWon.toFixed(2),
        houseProfit: (totalBets - totalWon).toFixed(2),
        count: totalCount,
      },
    ];

    const columns = [
      { Header: "Date", accessor: "date", align: "left" },
      { Header: "Total Bet", accessor: "totalBet", align: "right" },
      { Header: "Amount Won", accessor: "amountWon", align: "right" },
      { Header: "House Profit", accessor: "houseProfit", align: "right" },
      { Header: "Count", accessor: "count", align: "right" },
    ];

    const items = {
      columns,
      rows,
    };
    setBets(items);
  }, [data]);

  useEffect(() => {
    const load = async () => {
      if (!canUpdate) return;
      const result = await axios.get(
        process.env.REACT_APP_API_URI + "/api/v1/dashboard/stats/traditional",
        {
          withCredentials: true,
          params: {
            from: dateFrom,
            to: dateTo,
          },
        }
      );
      console.log("stats", result.data);
      setData(result.data);
    };

    load();
  }, [canUpdate, dateTo, dateFrom]);

  return (
    <div>
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="black">
                  Pro Prediction Stats From the beginning:{" "}
                  <DatePicker
                    selected={dateFrom}
                    onChange={(d) => setDateFrom(d)}
                  />
                  To the end:{" "}
                  <DatePicker
                    selected={dateTo}
                    onChange={(d) => setDateTo(d)}
                  />
                </MDTypography>
              </MDBox>
              {bets && (
                <MDBox pt={3}>
                  <DataTable
                    setCanUpdate={setCanUpdate}
                    table={bets}
                    isSorted={true}
                    canSearch={false}
                    entriesPerPage={false}
                    showTotalEntries={false}
                    noEndBorder
                  />
                </MDBox>
              )}
            </Card>
          </Grid>
        </Grid>
      </MDBox>
    </div>
  );
}

export default PredictionStats;
